export default __webpack_public_path__ + "static/media/Mobile_Hero_Image@1x.3fe5da24.png";